<template>
  <div class="selectZh" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="selectZh-nav">
      <van-nav-bar title="搜股票找组合" left-arrow @click-left="onClickLeft" />
    </div>

    <div class="header">
      <div class="h_select">
        <van-field
          v-model="value"
          left-icon="search"
          placeholder="请输入A股股票名称或股票代码"
          :right-icon="value && 'clear'"
          @click-right-icon="clickToClear"
          @search="onSearch"
        />

        <van-button type="primary" @click="onSearch">搜索</van-button>
      </div>
    </div>

    <div class="content">
      <ul
        class="sel_result"
        v-if="onSearchNum > 0 && queryList.length && !loading && !combinationState"
      >
        <li v-for="item in queryList" :key="item.Code" @click="handleClickCode(item)">
          <p class="name" v-html="item.HlName"></p>
          <p class="code" v-html="item.HlCode"></p>
        </li>
      </ul>

      <!-- 搜索之前的展示 -->
      <div class="sel_before" v-if="onSearchNum <= 0">
        <div>
          <img src="@/assets/image/homeSel.png" alt="" />
          <p>搜索股票近1月内关联的组合</p>
        </div>
      </div>

      <!-- 搜索无A股数据 -->
      <div
        class="sel_before"
        v-if="
          (onSearchNum > 0 && !queryList.length && !loading) ||
          (onSearchNum > 0 &&
            strategyArrTotalCount == 0 &&
            simulationArrTotalCount == 0 &&
            !loading)
        "
      >
        <div style="text-align: center">
          <img src="@/assets/image/notData.png" alt="" />
          <p>{{ titleValue2 }}近1月暂无关联的组合，换个股票</p>
          <p style="margin-top: -2px">搜索试试吧～</p>
        </div>
      </div>

      <!-- 搜索无组合数据 -->
      <!-- <div
        class="sel_before"
        v-if="
          onSearchNum > 0 && strategyArrTotalCount == 0 && simulationArrTotalCount == 0 && !loading
        "
      >
        <div style="text-align: center">
          <img src="@/assets/image/homeSel.png" alt="" />
          <p>{{ titleValue2 }}近1月暂无关联的组合，换个股票</p>
          <p style="margin-top: -2px">搜索试试吧～</p>
        </div>
      </div> -->

      <div v-if="combinationState">
        <!-- 搜索之后的展示 -->
        <div class="sel_after">
          <p class="top">
            <span>{{ titleValue }} </span>近1月内关联的组合
          </p>
          <div class="card">
            <van-tabs type="card" v-model="tabValue">
              <van-tab
                :title="`热门策略(${strategyArrTotalCount})`"
                v-if="strategyArrTotalCount > 0"
                name="a"
              ></van-tab>
              <van-tab
                :title="`热门模拟交易(${simulationArrTotalCount})`"
                v-if="simulationArrTotalCount > 0"
                name="b"
              ></van-tab>
            </van-tabs>
          </div>
        </div>

        <ul class="rm_ul" v-if="tabValue == 'a'">
          <li
            class="rm_ul_li"
            v-for="item in strategyArr"
            :key="item.s_id"
            @click="goclDetail(item)"
          >
            <p class="mingcheng">{{ item.s_name }}</p>

            <div class="center">
              <p class="left">
                <span class="name">日涨幅 </span>
                <span class="zf" :class="[judgeColor(item.RiZhangFu)]">
                  {{ toFixedNum(item.RiZhangFu * 100, 2, '%') }}
                </span>
              </p>

              <p class="right">
                <span class="name">最优平均涨跌幅:持股{{ item.BestAvgCycle }}天，</span>
                <span class="zf" :class="[judgeColor(item.BestAvgRate)]">
                  {{ toFixedNum(item.BestAvgRate * 100, 2, '%') }}</span
                >
              </p>
            </div>

            <ul class="btm">
              <li class="btm_li" style="text-align: left">
                <p>持有期</p>
                <p class="van-ellipsis">{{ item.BestAvgCycle }}天</p>
              </li>

              <li class="btm_li">
                <p>起点时间</p>
                <p>{{ formatDateString(item.historyData.StartDate) }}</p>
              </li>

              <li class="btm_li">
                <p>终止时间</p>
                <p>{{ formatDateString(item.historyData.EndDate) }}</p>
              </li>

              <li class="btm_li" style="text-align: right">
                <p>区间涨跌幅</p>
                <p :class="[judgeColor(item.historyData.SectionRate)]">
                  {{ toFixedNum(item.historyData.SectionRate * 100, 2, '%') }}
                </p>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="rm_ul" v-if="tabValue == 'b'">
          <li
            class="rm_ul_li"
            v-for="item in simulationArr"
            :key="item.capitalId"
            @click="goMnDetail(item)"
          >
            <p class="mingcheng">{{ item.name }}</p>

            <div class="center">
              <p class="left">
                <span class="name">创建后收益 </span>
                <span class="zf" :class="[judgeColor(item.totalRisk)]">
                  {{ toFixedNum(item.totalRisk * 100, 2, '%') }}
                </span>
              </p>

              <p class="right">
                <span class="name">最大年化收益 </span>
                <span class="zf" :class="[judgeColor(item.yearProfit)]">
                  {{ toFixedNum(item.yearProfit * 100, 2, '%') }}
                </span>
              </p>
            </div>

            <ul class="btm">
              <li class="btm_li btm_li2" style="text-align: left">
                <p>日期时间</p>
                <p>{{ formatDateString(item.dealDate) }}</p>
              </li>

              <li class="btm_li btm_li2">
                <p>操作</p>
                <p v-if="item.style == 1" class="red">调入</p>
                <p v-else class="green">调出</p>
                <!-- <p v-if="item.style == 3">止盈</p>
                <p v-if="item.style == 4">止损</p> -->
              </li>

              <li class="btm_li btm_li2">
                <p>状态</p>
                <p v-if="item.buySell == 'B'">持仓中</p>
                <p v-if="item.buySell == 'S'">-</p>
              </li>

              <li class="btm_li btm_li2" style="text-align: right">
                <p>平仓盈亏</p>
                <p :class="[judgeColor(item.profitLoss)]">
                  {{ toFixedNum(item.profitLoss * 100, 2, '%') }}
                </p>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// 引入lodash的debounce函数
import debounce from 'lodash/debounce';
import { getStockQuery, getAssemblyToStock } from '@/api/index.js';
import mixin from '@/mixins/index.js';
import { judgeColor, toFixedNum,compareVersions } from '@/utils/format';
import inobounce from 'inobounce'; //处理ios橡皮筋

export default {
  name: 'selectZh',
  mixins: [mixin],
  data() {
    return {
      value: '',
      selHint: '请输入A股股票名称，或股票代码',
      tabValue: 'a',
      queryList: [],
      onSearchNum: 0,
      loading: false,
      strategyArrTotalCount: 0,
      simulationArrTotalCount: 0,
      strategyArr: [],
      simulationArr: [],
      combinationState: 0,
      titleValue: '',
      titleValue2: '',
      isVip: false
    };
  },
  components: {},
  filters: {},
  created() {
    let u = navigator.userAgent;
    if (u.indexOf('iPhone') > -1) {
      inobounce.enable();
    }
  },

  //计算属性
  computed: {},
  async mounted() {},
  beforeDestroy() {
    inobounce.disable();
  },
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  methods: {
    judgeColor,
    toFixedNum,
    compareVersions,

    formatDateString: function (inputString) {
      // 正则表达式匹配 YYYYMMDD 格式
      const dateFormatRegex = /^\d{4}\d{2}\d{2}$/;

      // 如果输入字符串符合 YYYYMMDD 格式
      if (dateFormatRegex.test(inputString)) {
        // 使用正则表达式捕获年、月、日部分，然后拼接成 YYYY/MM/DD 格式
        const formattedString = inputString.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1/$2/$3');
        return formattedString;
      }

      // 如果不符合格式，则原样返回
      return inputString;
    },

    onClickLeft: function () {
      this.$router.go(-1);
    },

    clickToClear: function () {
      this.combinationState = false;
      this.onSearchNum = 0;
      this.value = '';
    },

    getStockQueryFun: function () {
      var _this = this; // 将this存储在变量中

      var params = {
        category: '沪A,深A,京A',
        q: _this.value
      };

      return getStockQuery(params)
        .then(function (res) {
          _this.queryList = res.Data.Docs;
          _this.loading = false;
          _this.$toast.clear();
        })
        .catch(function (err) {
          _this.loading = false;
          _this.$toast(err);
        });
    },

    //搜索因子  使用debounce包装onClickRight函数，延迟执行500毫秒
    onSearch: debounce(
      function () {
        var _this = this;

        if (_this.value == '') return false;
        _this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true
        });

        _this.titleValue2 = _this.value;
        _this.loading = true;
        _this.onSearchNum++;
        _this.combinationState = false;
        _this.getStockQueryFun();
      },
      500,
      { leading: true }
    ),

    //点击搜索出来的股票
    handleClickCode: async function (item) {
      this.loading = true;
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        message: '加载中...',
        forbidClick: true
      });
      this.value = item.Name;
      this.titleValue2 = item.Name;
      this.combinationState = true;
      await this.getAssemblyToStockFun(item.Symbol);
      if (this.strategyArrTotalCount > 0) {
        this.tabValue = 'a';
      } else {
        this.tabValue = 'b';
      }
    },

    getAssemblyToStockFun: function (stockCode) {
      this.combinationState = true;

      var params = {
        type: 'all', //all-获取所有类型数据yz-获取热门因子数据cl-获取热门策略数据mn-获取热门模拟数据
        start: 1,
        count: 100,
        stockCode: stockCode
      };
      return getAssemblyToStock(params)
        .then((res) => {
          this.loading = false;

          this.strategyArrTotalCount = res.data.strategyArr.TotalCount;
          this.simulationArrTotalCount = res.data.simulationArr.TotalCount;

          this.strategyArr = res.data.strategyArr.list;
          this.simulationArr = res.data.simulationArr.list;

          this.$toast.clear();
        })
        .catch((err) => {
          this.loading = false;

          this.$toast(err);
        });
    },

    // 跳转策略详情
    goclDetail: function (item) {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0703'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        location.href = '/clDetail?DZHSPECIAL=4325641&type=hot&s_id=' + item.s_id;
      }
    },

    // 跳转模拟详情
    goMnDetail: function (item) {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92) ) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71) ) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0704'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        location.href = '/mnDetail?DZHSPECIAL=4325641&type=hot&zj_id=' + item.capitalId;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.popup_body {
  padding: 16px;
  .title {
    color: #222;
    font-size: 16px;
    font-weight: 500;
  }
  .background {
    border-radius: 8px;
    background: #f7f7fc;
    padding: 16px;
    margin-top: 19px;
    line-height: 25px;
    .label {
      color: #999;
      font-size: 14px;
    }
    .Desc {
      color: #555;
    }
  }
  .btn {
    padding: 24px 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .cancel,
    .add {
      font-size: 16px;
      border-radius: 20px;
      height: 41px;
    }
    .cancel {
      width: 120px;
      border: 1px solid #286df7;
      background: #fff;
      color: #286df7;
    }
    .add {
      width: 215px;
      border: 1px solid #286df7;
      background: #286df7;
      color: #fff;
    }
  }
}
.selectZh {
  position: relative;
  background: #f7f7fc;
  min-height: 100vh;
  .selectZh-nav {
    ::v-deep {
      .van-hairline--bottom::after {
        display: none;
      }
      .van-nav-bar {
        padding-top: 40px;
      }
      .van-nav-bar__left,
      .van-nav-bar__right {
        padding: 0 16px;
        .van-icon,
        .van-nav-bar__text {
          color: #333;
        }
      }
      .van-nav-bar__title {
        color: #333;
      }
    }
  }
  .header {
    padding: 16px;
    background: #fff;
    position: sticky;
    top: 0;
    width: 100%;
    .h_select {
      display: flex;
      align-items: center;
      .van-icon-arrow-left {
        font-size: 20px;
        margin-right: 10px;
        color: #333;
      }
      .van-cell {
        padding: 0;
        border-radius: 20px;
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
        background: #f7f7fc;
        &::after {
          display: none;
        }
      }
      ::v-deep {
        .van-button {
          border-radius: 4px;
          background: #286df7;
          margin-left: 12px;
          border: none;
          width: 45px;
          height: 28px;
          padding: 0;
          flex-shrink: 0;
        }
      }
    }
  }
  .content {
    .sel_before {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      height: calc(100vh - 150px);
      img {
        width: 157px;
        height: 130px;
        display: inline-block;
      }
      p {
        color: rgba(0, 0, 0, 0.3);
        font-size: 14px;
        margin-top: 12px;
      }
    }

    .sel_after {
      background: #fff;
      margin-top: 4px;
      padding: 11px 16px;
      .top {
        color: #555;
        font-size: 14px;
        font-weight: 400;
        span {
          color: #286df7;
        }
      }
      .card {
        margin-top: 6px;
        ::v-deep {
          .van-tabs__wrap {
            height: auto;
          }
          .van-tabs__nav--card {
            border: none;
            margin: 0;
          }
          .van-tab {
            flex: none;
            border-radius: 6px;
            border: 1px solid #f5f6f9;
            color: #999;
            padding: 12px 9px;
            margin-right: 8px;
            font-size: 13px;
          }
          .van-tab--active {
            background: #eaf0fe;
            border: 1px solid #eaf0fe;
            color: #286df7;
          }
        }
      }
    }

    .rm_ul {
      padding: 8px 16px;
      height: calc(100vh - 232px);
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;

      .rm_ul_li {
        border-radius: 4px;
        background: #fff;
        padding: 10px 15px;
        margin-bottom: 8px;
        .mingcheng {
          color: #555;
          font-size: 15px;
          font-weight: 500;
        }
        .center {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 5px;
          padding-bottom: 10px;
          border-bottom: 1px dashed #d3d3d3;
          .left,
          .right {
            display: flex;
            align-items: center;
          }
          .name {
            color: #999;
            font-size: 12px;
            font-weight: 500;
          }
          .zf {
            font-size: 15px;
            font-weight: 500;
            margin-left: 2px;
          }
        }
        .btm {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;
          .btm_li {
            text-align: center;
            &:nth-child(1) {
              width: 21%;
            }
            &:nth-child(2) {
              width: 29%;
            }
            &:nth-child(3) {
              width: 29%;
            }
            &:nth-child(4) {
              width: 21%;
            }
            p {
              &:first-child {
                color: #999;
                font-size: 12px;
              }
              &:last-child {
                color: #555;
                font-size: 15px;
                font-weight: 500;
              }
            }
          }

          .btm_li2 {
            text-align: center;
            &:nth-child(1) {
              width: 29%;
            }
            &:nth-child(2) {
              width: 21%;
            }
            &:nth-child(3) {
              width: 29%;
            }
            &:nth-child(4) {
              width: 21%;
            }
            p {
              &:first-child {
                color: #999;
                font-size: 12px;
              }
              &:last-child {
                color: #555;
                font-size: 15px;
                font-weight: 500;
              }
            }
          }
        }
      }
    }
  }
}

.sel_result {
  position: fixed;
  width: 100%;
  top: 140px;
  left: 0;
  height: calc(100vh - 140px);
  background: #fff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  li {
    padding: 5px 16px;
    ::v-deep {
      b {
        color: #286df7;
      }
    }
    .name {
      color: #222;
      font-size: 16px;
    }
    .code {
      color: #999;
      font-size: 12px;
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .selectZh {
    background: #0c0f13;
  }
  .selectZh-nav {
    .van-nav-bar {
      background: #181a22;
      ::v-deep {
        .van-icon,
        .van-nav-bar__title {
          color: #fff;
        }
      }
    }
  }
  .header {
    background: #181a22;
    ::v-deep {
      .van-cell {
        background: #1d202d !important;
      }
      .van-icon-search {
        color: #6b7687;
      }
      .van-field__control {
        color: #e4e9fe;
      }
    }
  }
  .sel_result {
    background: #181a22;
    .name {
      color: #e4e9fe;
    }
    .code {
      color: #6b7687;
    }
  }
  .content {
    .sel_after {
      background: #181a23 !important;
      .top {
        color: #aab9d1 !important;
      }
      ::v-deep {
        .van-tabs__nav {
          background: #181a23;
        }
        .van-tab--active {
          background: #1f2f4f !important;
          border: 1px solid #1f2f4f !important;
        }
        .card {
          .van-tab {
            border: 1px solid #46484f;
          }
        }
      }
    }
    .rm_ul {
      .rm_ul_li {
        background: #272935;
        .mingcheng {
          color: #aab9d1;
        }
        .center {
          border-bottom: 1px dashed #353a50;
          .name {
            color: #aab9d1;
          }
        }
        .btm {
          .btm_li {
            p {
              &:first-child {
                color: #8c96a7;
              }
              &:last-child {
                color: #e4e9fe;
              }
            }
          }
        }
      }
    }
  }
  .sel_before {
    p {
      color: #b8bbca !important;
    }
  }
}
</style>
